"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgImpellarOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm11.39 17.75A8 8 0 0123.16 21a8.37 8.37 0 01-3.16-.52 6 6 0 001.89-3.25 10.32 10.32 0 003.82-4 9.75 9.75 0 001-2.7 11.85 11.85 0 01.7 9.17zM12 16a4 4 0 114 4 4 4 0 01-4-4zm12.93-8a8.23 8.23 0 01-1 4.3 8.53 8.53 0 01-2.06 2.48A6 6 0 0020 11.54a10.35 10.35 0 00-1.51-5.29A10 10 0 0016.66 4a12 12 0 018.27 4zM13.55 4.25a8.13 8.13 0 013.24 3 8.7 8.7 0 011.11 3A5.94 5.94 0 0016 10a6.1 6.1 0 00-1.87.3A10.39 10.39 0 008.8 9a10 10 0 00-2.8.45 12.06 12.06 0 017.55-5.2zm-8.94 8A8.21 8.21 0 018.84 11a8.57 8.57 0 013.18.55 6 6 0 00-1.89 3.25 10.32 10.32 0 00-3.82 3.95 9.75 9.75 0 00-1 2.7 11.85 11.85 0 01-.7-9.17zM7.07 24a8.23 8.23 0 011-4.3 8.53 8.53 0 012.06-2.48A6 6 0 0012 20.46a10.35 10.35 0 001.51 5.29A10 10 0 0015.34 28a12 12 0 01-8.27-4zm11.38 3.76a8.13 8.13 0 01-3.24-3 8.7 8.7 0 01-1.11-3A5.94 5.94 0 0016 22a6.1 6.1 0 001.87-.3A10.37 10.37 0 0023 23h.2a10 10 0 002.8-.45 12.06 12.06 0 01-7.55 5.2z" })));
}
exports.default = SvgImpellarOutline;
//# sourceMappingURL=ImpellarOutline.js.map